import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityRequestAprv } from "../../entity/EntityRequestAprv";

export class DtoRequestAprvsGetRes extends EntityRequestAprv {
  public items: EntityRequestAprv[]  = [];
}
